import React from 'react';
import styled from 'react-emotion';
import {
    colors,
    fontSize,
    letterSpacing,
    lineHeight,
    mq,
    rWidth,
} from '../../../css';

export default ({
    heading,
    text,
    left = true,
    backgroundColor = colors.white,
    color = colors.blue,
    order = 0,
    id = '',
    tinyHeading,
}) => (
    <s.wrapper id={id} {...{ backgroundColor, left, order }}>
        <s.heading {...{ color }}>
            {tinyHeading ? <h3>{heading}</h3> : <h2>{heading}</h2>}
        </s.heading>
        <s.content {...{ color }}>{text}</s.content>
    </s.wrapper>
);

const s = {};

s.wrapper = styled('div')`
    background: ${props => props.backgroundColor};
    ${props =>
        mq({
            order: [props.order, props.order, props.order, 0],
        })};
    ${props =>
        props.left
            ? mq({
                  paddingLeft: [20, 60, 60, 30, rWidth(240 / 2), rWidth(240)],
                  paddingRight: [20, 60, 60, 30, rWidth(148 / 2), rWidth(148)],
              })
            : mq({
                  paddingLeft: [
                      20,
                      60,
                      60,
                      30,
                      rWidth(148 - 80 / 2),
                      rWidth(148 - 80),
                  ],
                  paddingRight: [
                      20,
                      60,
                      60,
                      30,
                      rWidth(240 + 80 / 2),
                      rWidth(240 + 80),
                  ],
              })};
    ${mq({
        width: ['100%', '100%', '100%', '50%'],
        paddingTop: [60, 60, 80, 80, 80, 120],
        paddingBottom: [60, 60, 80, 80, 80, 120],
    })};
`;

s.heading = styled('div')`
    line-height: ${lineHeight(53, 45)};
    h2,
    h3 {
        margin: 0 0 1.5em;
        color: ${props => props.color};
        text-align: left;
        ${mq({
            paddingRight: [20, 20, 20, 0],
        })};
    }
    h2 {
        letter-spacing: ${letterSpacing(200)};
        ${mq({
            fontSize: [
                fontSize(20),
                fontSize(25),
                fontSize(25),
                fontSize(20),
                fontSize(30),
            ],
        })};
    }
    h3 {
        font-weight: 600;
        ${mq({
            marginLeft: [0, 0, 0, 0, rWidth(80)],
            fontSize: [fontSize(14), fontSize(16), fontSize(16), fontSize(16)],
        })};
    }
`;

s.content = styled('div')`
    line-height: ${lineHeight(32, 16)};
    letter-spacing: ${letterSpacing(11)};
    color: ${props => props.color};
    ${mq({
        marginLeft: [0, 0, 0, 0, rWidth(80)],
        fontSize: [fontSize(14), fontSize(16), fontSize(16), fontSize(16)],
    })};
`;



// WEBPACK FOOTER //
// ./src/components/common/textBlock/textBlock.component.js